module.exports = __webpack_public_path__ + "static/media/编组44@2x.f82689bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/编组44@2x.png
// module id = 1547
// module chunks = 0